import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Button, Icon } from '@nvidia/kaizen-ui'
import Modal from 'react-modal'
import styled from 'styled-components'
import Markdown from 'react-markdown'
import { Article } from '../../components'
import headerOne from '../../images/header_1.gif'
import headerTwo from '../../images/header_2.gif'
import { termsOfUse } from './termsOfUse'
import './introduction.css'

const Header = styled.div`
  display: flex;
  margin-bottom: 56px;

  img:first-child {
    margin-right: 14px;
  }

  @media only screen and (max-width: 600px) {
    flex-wrap: wrap;
    margin-bottom: 14px;

    img {
      width: 49%;
      height: 49%;
    }

    img:first-child {
      margin-right: 7px;
    }
  }
`

const Tagline = styled.p`
  color: #050505;
  font-family: 'DINWebPro', 'Open Sans', sans-serif;
  font-size: 21px;
  letter-spacing: -0.2px;
  line-height: 28px;
  text-align: center;
  width: 650px;
  margin-bottom: 28px;

  @media only screen and (max-width: 600px) {
    width: 100%;
    font-size: 14px;
    letter-spacing: -0.13px;
    line-height: 21px;
    margin-bottom: 14px;
  }
`

const Terms = styled.p`
  color: #9E9E9E;

  @media only screen and (max-width: 600px) {
    font-size: 10.5px;
    line-height: 15px;
    text-align: center;

    > a {
      font-size: 10.5px;
      line-height: 15px;
      text-align: center;
    }
  }
`

export class Introduction extends Component {
  state = {
    showModal: false
  }

  openModal = () => this.setState({ showModal: true })
  closeModal = () => this.setState({ showModal: false })

  render() {
    return (
      <Article className='introduction'>
        <h2>Image Inpainting</h2>
        <Header>
          <img src={headerOne} title='' alt='' className='header-image' />
          <img src={headerTwo} title='' alt='' className='header-image' />
        </Header>
        <Tagline>Image Inpainting lets you edit images with a smart retouching brush. Use the power of NVIDIA GPUs and deep learning algorithms to replace any portion of the image.</Tagline>
        <Button className='get-started' primary as='div'>
          <Link to='selection'>Let's Get Started</Link>
        </Button>
        <Terms>By clicking the “Let’s Get Started” button, you are agreeing to the <a onClick={this.openModal}>Terms and Conditions.</a></Terms>
        <Modal
          title='Terms of Use'
          isOpen={this.state.showModal}
          className='ui modal'
          overlayClassName='ui overlay'
        >
          <div className='terms-of-use'>
            <h2 className='title'>Terms of Use</h2>
            <Markdown source={termsOfUse} />
          </div>
          <Button className='close-modal' onClick={this.closeModal}>
            Close
          </Button>
          <Icon className='close-icon' name='close-fill' onClick={this.closeModal} />
        </Modal>
      </Article>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Introduction/Introduction.js